import { useSelector } from 'react-redux';

import { RootState } from 'src/shared/utils/redux/store';
import { LoadingParam } from './types';

export default function DataModel() {
  const selectLoading = (param: LoadingParam) => (state: RootState) => state.ui.loading[param];

  const { config, errorMessage, errorPopup, successMessage } = useSelector(
    (state: RootState) => state.ui,
  );

  return {
    primaryActionLoading: useSelector(selectLoading('primaryAction')),
    overlayLoading: useSelector(selectLoading('overlay')),
    config,
    errorMessage,
    errorPopup,
    successMessage,
  };
}
